import { isEmpty, last } from 'lodash';
import moment from 'moment';

// Shared by the per-booking summary row and the occasion header so the two can
// never disagree about whether a confirmation / gameplay email has been sent.
export const getLatestNotificationProperties = (notification = {}, confirmationsOrCodes, booking) => {
    // FIXME: isConfirmationSent is a legacy variable. There were no date stored in the past.  Remove the following block of code when we are certain, we don't need them
    if (
        notification.isConfirmationSent &&
        notification.isConfirmationSent === true &&
        confirmationsOrCodes === 'confirmations'
    ) {
        return null;
    }

    // FIXME: isCodeSent is a legacy variable. There were no date stored in the past. Remove the following block of code when we are certain, we don't need them
    if (notification.isCodeSent && notification.isCodeSent === true && confirmationsOrCodes === 'codes') {
        return null;
    }

    if (notification && notification[confirmationsOrCodes] && notification[confirmationsOrCodes].length > 0) {
        const notificationDetail = last(notification[confirmationsOrCodes] || []);
        if (notificationDetail && !isEmpty(notificationDetail)) {
            switch (confirmationsOrCodes) {
                case 'confirmations':
                    return {
                        ...notificationDetail,
                        date: moment(notificationDetail.dateTime).utc().format('DD MMM YYYY'),
                    };
                case 'codes':
                    if (!notification.lastCodeSent || notification.lastCodeSent?.isValid) {
                        return {
                            ...notificationDetail,
                            date: moment(notificationDetail.dateTime).utc().format('DD MMM YYYY'),
                        };
                    } else {
                        return null;
                    }
                default:
                    return null;
            }
        }
    }

    return null;
};

// 'sent' | 'queued' | 'none'
// A confirmation notification entry is written with status 'Created' when queued,
// and flipped to 'Sent' by the mailer callback.
export const getConfirmationState = (booking = {}) => {
    const latest = getLatestNotificationProperties(booking.notification || {}, 'confirmations');
    if (isEmpty(latest)) return 'none';
    return latest.status?.toUpperCase() === 'CREATED' ? 'queued' : 'sent';
};

// 'sent' | 'queued' | 'none'
// Mirrors the isCodeSent semantics the API filters on: a codes entry must exist
// (and not have been invalidated by a route change), and deliveryQueueStatus
// carries the queued -> sent transition. Only an explicit 'CREATED' counts as
// queued, so legacy bookings with no deliveryQueueStatus still read as sent.
export const getGameplayState = (booking = {}) => {
    const latest = getLatestNotificationProperties(booking.notification || {}, 'codes', booking);
    if (isEmpty(latest)) return 'none';
    return booking.deliveryQueueStatus === 'CREATED' ? 'queued' : 'sent';
};

// Tooltip / button label for either action, e.g. "Sent 30 Jul 2026 by Jeremy".
export const getNotificationStateText = (state, latest, { idleText, sentPrefix = '' }) => {
    if (state === 'none' || isEmpty(latest)) return idleText;

    const statusText = state === 'queued' ? 'In Queue' : 'Sent';
    let text = `${sentPrefix}${statusText} ${latest.date}`;
    if (latest.userGivenName) {
        text = `${text} by ${latest.userGivenName}`;
    }
    return text;
};

export const NOTIFICATION_STATE_COLORS = {
    none: 'rgb(211, 47, 47)',
    queued: '#616161',
    sent: 'rgb(102, 205, 170)',
};
